import {
    Component,
    OnInit,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { StepNavigationButtonService } from '../../../../shared/services/step-navigation-button/step-navigation-button.service';
import { StepNavigationService } from '../../../../shared/services/step-navigation/step-navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { StepNavigationButtonVisibilityService } from '../../../../shared/services/step-navigation-button-visibility/step-navigation-button-visibility.service';
import { GoContactAssistanceModalComponent } from '../go-contact-assistance-modal/go-contact-assistance-modal.component';
import { NavigationText } from '../../../../../../core/constants/navigation-text';

@Component({
    selector: 'app-go-application-page-navigation-base',
    changeDetection: ChangeDetectionStrategy.Eager,
    template:
        '<!-- This component serves as a base and does not render any content -->',
})
export abstract class GoApplicationPageNavigationBaseComponent
    implements OnInit, OnDestroy
{
    protected destroy$ = new Subject<void>();

    constructor(
        protected readonly stepNavigationService: StepNavigationService,
        protected readonly stepNavigationButtonService: StepNavigationButtonService,
        protected readonly stepNavigationOptionsService: StepNavigationButtonVisibilityService,
        protected readonly dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.subscribeToStepChanges();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    previous() {
        this.stepNavigationService.triggerPreviousClick();
    }

    next() {
        this.stepNavigationService.triggerNextClick();
    }

    protected abstract subscribeToStepChanges(): void;

    protected openContactForAssistanceModal(): void {
        this.dialog.open(GoContactAssistanceModalComponent, {
            data: {
                title: NavigationText.CONTACT_EWA_FOR_ASSISTANCE,
                cancelTitle: 'Close',
            },
            width: '400px',
        });
    }
}
